import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateField } from "@mui/x-date-pickers/DateField";
import dayjs from "dayjs";
import makeStyles from "@mui/styles/makeStyles";
import { postDataWithToken } from "../../services/PostDataService";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../context/AuthContext";
import PulseLoader from "react-spinners/PulseLoader";
import { useTheme } from "@mui/material/styles";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CardForm from "./CardForm";
const useStyles = makeStyles((theme) => ({
   
  
  
   
}));

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render. 

export default function AddNewCardForm({ cardList,getCardList, handleAddCardClose }) {
  const classes = useStyles();
  const theme = useTheme(); 
  const { login, admin_panel_user, logout } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar(); 
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [publicKey, setPublicKey] = useState(null);
  const [intend, setIntend] = useState(null);
  //   publicKey, setupIntent
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
 
  const options = {
    // passing the client secret obtained from the server
    // clientSecret: '{{CLIENT_SECRET}}',
    clientSecret: "",
  };
  const getConfigData = async () => {
    // setLoading(true);

    let data = {
      storeId: admin_panel_user.selectedStoreId,
    };

    let response = await postDataWithToken(
      "cardConfigInfo",
      data,
      admin_panel_user,
      logout
    );
    // console.log("response", response?.data);
    // console.log(
    //   "response?.data?.data?.publicKey",
    //   response?.data?.data?.publicKey
    // );
    if (response?.data?.code === 200) {
      setPublicKey(response?.data?.data?.publicKey);
      setIntend(response?.data?.data?.setupIntent);
      setShowForm(true);
    } else {
      handleSnakbarOpen(response?.data.message, "error");
      setLoading(false);
    }
  };

  useEffect(() => {
    getConfigData();
  }, []);
  
  return (
    <>
      {/* <form onSubmit={handleAddNewCard}> */}
      {/* <form> */}
      {showForm && (
        <Elements stripe={loadStripe(publicKey)}>
          <CardForm
          cardList={cardList}
            publicKey={publicKey}
            intend={intend}
            getCardList={getCardList}
            handleAddCardClose={handleAddCardClose}
          />
        </Elements>
      )}

      {/* </form> */}
    </>
  );
}
